import React from 'react';
import InputField from '../../../../common/InputField';

const ContactDetails = () => {
  return (
    <div className="basic-details-wrapper">
      <h3>Contact Details</h3>
      <InputField name={['contact', 'firstName']} label={'First Name'} isDisabled={true} />
      <InputField name={['contact', 'lastName']} label={'Last Name'} isDisabled={true} />
      {/* <InputField
                name={['contact', 'designation']}
                label={'Designation'}
                isDisabled={true}
            /> */}
      <InputField name={['contact', 'email']} label={'Email Address'} isDisabled={true} />
      <InputField name={['contact', 'countryCode']} label={'Country Code'} isDisabled={true} />
      <InputField name={['contact', 'phone']} label={'Phone Number'} isDisabled={true} />
    </div>
  );
};

export default ContactDetails;
